import script from "./Catalog.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalog.vue?vue&type=script&setup=true&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=75dd0d0c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75dd0d0c"]])

export default __exports__